<div *transloco="let t" class="w-screen h-screen animated-bg overflow-hidden">
    @if(currentStep == -2){<div class="w-fit mx-auto text-white pt-5 text-[16px] flex items-center gap-2.5">
        {{t('joinLiveLink')}} <a class="font-bold hover:underline text-[24px]" target="_blank"
            [href]="origin+'/live/'+ idLive">{{origin+'/live/'+ idLive}}</a></div>
    <div class="text-center text-white">{{t('or')}}</div>}
    @if(idLive && currentStep == -2){<div class="flex flex-wrap gap-5 mx-auto mt-10 w-fit items-center">
        <div
            class="h-24 w-16 bg-blue-300 text-[70px] text-white font-semibold flex items-center place-content-center rounded-md">
            {{idLive[0]}}</div>
        <div
            class="h-24 w-16 bg-blue-300 text-[70px] text-white font-semibold flex items-center place-content-center rounded-md">
            {{idLive[1]}}</div>
        <div
            class="h-24 w-16 bg-blue-300 text-[70px] text-white font-semibold flex items-center place-content-center rounded-md">
            {{idLive[2]}}</div>
        <div
            class="h-24 w-16 bg-blue-300 text-[70px] text-white font-semibold flex items-center place-content-center rounded-md">
            {{idLive[3]}}</div>
        <div
            class="h-24 w-16 bg-blue-300 text-[70px] text-white font-semibold flex items-center place-content-center rounded-md">
            {{idLive[4]}}</div>
        <div
            class="h-24 w-16 bg-blue-300 text-[70px] text-white font-semibold flex items-center place-content-center rounded-md">
            {{idLive[5]}}</div>

    </div>}
    @if(qrCode && idLive && currentStep == -2){<div class="size-[200px] mx-auto mt-10 rounded-md overflow-hidden">
        <!-- <qrcode [qrdata]="qrCode" [width]="200"></qrcode> -->
        <qrcode [qrdata]="'http://192.168.1.76:4200/live/' + idLive" [width]="200"></qrcode>
    </div>}
    @if(currentStep == -2){<div class="flex flex-wrap gap-5 px-10 place-content-center items-start h-fit mt-10">
        @for (user of users; track $index) {
        <div class="relative" [id]="'container-' + user.id">
            <div [id]="user.id" [style.background]="user.color ?? 'rgba(255, 255, 255 ,0.25)'" [ngClass]="{'!bg-red-500': user.kicked && user.left_at , '!bg-gray-600': !user.kicked && user.left_at}"
                style="transition-duration: 250ms;" class="px-2 rounded-full border-black backdrop-blur-[50px]">
                <div class="flex gap-2 items-center">
                    <div class="text-[40px]">{{user?.profile_icon}}</div>
                    <div class="text-white font-bold text-[24px]">{{user?.nickname}}</div>
                    <div [ngClass]="{'pointer-events-none': user.kicked}" (click)="userToBan = user"
                        class="size-10 cursor-pointer opacity-0 hover:opacity-100 transition-all">
                        <svg fill="white" xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 640 640"><!--!Font Awesome Free v7.2.0 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2026 Fonticons, Inc.-->
                            <path
                                d="M201.6 217.4L182.9 198.7C170.4 186.2 170.4 165.9 182.9 153.4L297.6 38.6C310.1 26.1 330.4 26.1 342.9 38.6L361.6 57.4C374.1 69.9 374.1 90.2 361.6 102.7L246.9 217.4C234.4 229.9 214.1 229.9 201.6 217.4zM308 275.7L276.6 244.3L388.6 132.3L508 251.7L396 363.7L364.6 332.3L132.6 564.3C117 579.9 91.7 579.9 76 564.3C60.3 548.7 60.4 523.4 76 507.7L308 275.7zM422.9 438.6C410.4 426.1 410.4 405.8 422.9 393.3L537.6 278.6C550.1 266.1 570.4 266.1 582.9 278.6L601.6 297.3C614.1 309.8 614.1 330.1 601.6 342.6L486.9 457.4C474.4 469.9 454.1 469.9 441.6 457.4L422.9 438.7z" />
                        </svg>
                    </div>
                </div>
            </div>
        </div>
        }
    </div>}
    @if(currentStep >= 0 && showTimer){<div class="fixed cursor-pointer left-2 bottom-12 size-[50px] z-20 bg-white flex gap-5 rounded-lg place-content-center">
        @if(barTimeStopped){<svg (click)="startBarTimer()" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 640"><!--!Font Awesome Free v7.2.0 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2026 Fonticons, Inc.--><path d="M187.2 100.9C174.8 94.1 159.8 94.4 147.6 101.6C135.4 108.8 128 121.9 128 136L128 504C128 518.1 135.5 531.2 147.6 538.4C159.7 545.6 174.8 545.9 187.2 539.1L523.2 355.1C536 348.1 544 334.6 544 320C544 305.4 536 291.9 523.2 284.9L187.2 100.9z"/></svg>}
        @if(!barTimeStopped){<svg (click)="stopBarTimer()" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 640"><!--!Font Awesome Free v7.2.0 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2026 Fonticons, Inc.--><path d="M176 96C149.5 96 128 117.5 128 144L128 496C128 522.5 149.5 544 176 544L240 544C266.5 544 288 522.5 288 496L288 144C288 117.5 266.5 96 240 96L176 96zM400 96C373.5 96 352 117.5 352 144L352 496C352 522.5 373.5 544 400 544L464 544C490.5 544 512 522.5 512 496L512 144C512 117.5 490.5 96 464 96L400 96z"/></svg>}
    </div>

<div (click)="!barTimeStopped ? stopBarTimer() : null;endQuestion()" class="fixed cursor-pointer left-[70px] bottom-12 size-[50px] z-20 bg-white flex gap-5 rounded-lg place-content-center">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 640"><!--!Font Awesome Free v7.2.0 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2026 Fonticons, Inc.--><path d="M535.1 342.6C547.6 330.1 547.6 309.8 535.1 297.3L375.1 137.3C362.6 124.8 342.3 124.8 329.8 137.3C317.3 149.8 317.3 170.1 329.8 182.6L467.2 320L329.9 457.4C317.4 469.9 317.4 490.2 329.9 502.7C342.4 515.2 362.7 515.2 375.2 502.7L535.2 342.7zM183.1 502.6L343.1 342.6C355.6 330.1 355.6 309.8 343.1 297.3L183.1 137.3C170.6 124.8 150.3 124.8 137.8 137.3C125.3 149.8 125.3 170.1 137.8 182.6L275.2 320L137.9 457.4C125.4 469.9 125.4 490.2 137.9 502.7C150.4 515.2 170.7 515.2 183.2 502.7z"/></svg>
    </div>
}
    @if(users.length == 0){
    <div class="fixed text-white font-semibold text-[24px] bottom-10 left-0 w-screen">
        <div class="text-center">{{t('needPlayer')}}</div>
        <div class="text-center">{{t('noPlayer')}}</div>
    </div>
    }
    
    @if(currentStep == -1){
    <div class="h-[100dvh] w-screen flex items-center place-content-center">
        <div class="size-[200px] flex place-content-center items-center rounded-full border-[10px] border-white text-white font-bold text-[70px] animate-ping"
            id="timer-start">
            {{timerStart}}
        </div>
    </div>
    }
    @if(currentStep >= 0 && !endQuiz){
    <div class="mt-10 text-[32px] text-white font-bold">{{quiz.questions[currentStep].title}}</div>
    @if(quiz.questions[currentStep].type == 1){
    <div>{{t('multipleExplanation')}}</div>
    }
    @if(quiz.questions[currentStep].type == 2){<div>{{t('buzzerExplanation')}}</div>}
    @if(quiz.questions[currentStep].type == 3){<div>{{t('mapExplanation')}}</div>}
    @if(quiz.questions[currentStep].type == 4){<div>{{t('numberExplanation')}}</div>}
    <!-- @if(quiz.questions[currentStep].type == 5){<div>{{t('multipleAnswers')}}</div>}
    @if(quiz.questions[currentStep].type == 6){<div>{{t('multipleAnswers')}}</div>} -->
    @if(showTimer){<div id="timer-question" class="fixed bottom-0 left-0 z-20 w-screen h-10 overflow-hidden">
        <div class="w-screen h-10 animated-bar-timer"></div>
    </div>}
    }
    @if(endQuiz){
        <div>QUIZ FINITO AVETE PERSO</div>
    }
    @if(showRank){
        <div class="p-10">
            <div class="flex gap-5 items-end mx-auto w-fit">
                <div class="w-[250px] h-[400px] bg-gray-400"><div class="mt-5 text-white text-[32px] font-bold text-center">{{rankedUsers[1].emoji}} {{rankedUsers[1].username}}</div><div class="text-white font-bold text-[20px] mt-10 text-center">{{rankedUsers[1].points}}</div></div>
                <div class="w-[250px] h-[500px] bg-yellow-400"><div class="mt-5 text-white text-[32px] font-bold text-center">{{rankedUsers[0].emoji}} {{rankedUsers[0].username}}</div><div class="text-white font-bold text-[20px] mt-10 text-center">{{rankedUsers[0].points}}</div></div>
                <div class="w-[250px] h-[300px] bg-orange-900"><div class="mt-5 text-white text-[32px] font-bold text-center">{{rankedUsers[2].emoji}} {{rankedUsers[2].username}}</div><div class="text-white font-bold text-[20px] mt-10 text-center">{{rankedUsers[2].points}}</div></div>
            </div>
        @for (user of rankedUsers.slice(3); track $index) {
        <div class="px-2 mt-5 mx-auto max-w-[500px] rounded-full border-black bg-white bg-opacity-25 backdrop-blur-[50px]">
            <div class="flex gap-2 items-center">
                <div class="text-white font-bold text-[40px] pl-5">{{$index + 4}}</div>
                <div class="text-[40px]">{{user.emoji}}</div>
                <div class="text-white font-bold text-[24px]">{{user.username}}</div>
                <div class="text-white font-bold text-[24px]">{{user.points}}</div>
            </div>
        </div>
        }
        </div>
    }
    <div class="fixed right-6 bottom-16 z-10">
        <div class="w-[20px] ml-auto mr-20 select-none relative top-[-30px]" id="fountain"></div>
    </div>
    @if(userToBan){
        <std-modal [show]="userToBan ? true : false" (close)="userToBan = null">
            <div header class="text-white font-bold">{{t('deleteQuiz')}}</div>
                <div content class="text-black">
                    <div class="py-5">{{t('areYouSure',{name:userToBan?.nickname})}}</div>
                    <div class="flex place-content-between">
                        <div class="cursor-pointer text-[18px] font-semibold border-black border-[3px] rounded-full w-[calc(50%-20px)] text-center py-1" (click)="userToBan = null">{{t('no')}}</div>
                        <div class="cursor-pointer text-[18px] font-semibold border-black border-[3px] rounded-full w-[calc(50%-20px)] text-center py-1" (click)="banUser()">{{t('yes')}}</div>
                    </div>
                </div>
        </std-modal>
    }
</div>